<!-- src/components/layout/Navbar.vue -->
<template>
  <nav class="navbar navbar-expand-lg navbar-dark">
    <div class="container-fluid">
      <BrandLogo small />
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link class="nav-link" :class="{ active: $route.path === '/' }" to="/">
              Dashboard
            </router-link>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" :class="{ active: $route.path.includes('/patients') }" to="/patients">
              Pacientes
            </router-link>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" :class="{ active: $route.path.includes('/appointments') }" to="/appointments">
              Citas
            </router-link>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" :class="{ active: $route.path.includes('/clinical-histories') }"
              to="/clinical-histories">
              Historias Clínicas
            </router-link>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" :class="{ active: $route.path.includes('/treatment-plans') }"
              to="/treatment-plans">
              Planes de Tratamientos
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/estadisticas" class="nav-link">
              Estadísticas
            </router-link>
          </li>
        </ul>

        <!-- User dropdown if logged in -->
        <ul class="navbar-nav" v-if="isLoggedIn">
          <li class="nav-item dropdown position-relative">
            <a class="nav-link dropdown-toggle user-dropdown" href="#" id="navbarDropdown" role="button"
              @click="toggleUserDropdown" aria-expanded="false">
              {{ displayName }}
            </a>
            <ul class="dropdown-menu dropdown-menu-end custom-dropdown-menu" :class="{ show: showUserDropdown }"
              aria-labelledby="navbarDropdown">
              <li v-if="userData && userData.rol">
                <span class="dropdown-item user-role">{{ userData.rol }}</span>
              </li>
              <li v-if="userData && userData.rol">
                <hr class="dropdown-divider">
              </li>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="handleLogout">Cerrar sesión</a>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Login button if not logged in -->
        <div class="d-flex" v-else>
          <router-link class="btn btn-outline-light" to="/login">
            Iniciar sesión
          </router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import BrandLogo from '@/components/layout/BrandLogo.vue';
import { authService } from '@/services/api';

export default {
  name: 'Navbar',
  components: {
    BrandLogo
  },
  data() {
    return {
      isLoggedIn: false,
      userData: null,
      showUserDropdown: false
    };
  },
  computed: {
    displayName() {
      if (this.userData) {
        if (this.userData.first_name && this.userData.last_name) {
          return `${this.userData.first_name} `;
          
        }
        return this.userData.username || 'Usuario';
      }
      return 'Usuario';
    }
  },
  created() {
    // Check authentication status when component is created
    this.checkAuthStatus();
  },
  mounted() {
    // Add a click event listener to close the dropdown when clicking outside
    document.addEventListener('click', this.handleOutsideClick);

    // Listen for route changes to update auth status
    this.$router.afterEach(() => {
      this.checkAuthStatus();
    });
  },
  beforeUnmount() {
    // Remove the event listener when the component is destroyed
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    checkAuthStatus() {
      // Check if user is authenticated
      this.isLoggedIn = authService.isAuthenticated();

      // If authenticated but no user data, fetch it
      if (this.isLoggedIn && !this.userData) {
        this.fetchUserData();
      }
    },

    fetchUserData() {
      authService.getUserInfo()
        .then(response => {
          console.log('User data fetched:', response.data);
          this.userData = response.data;
        })
        .catch(error => {
          console.error('Error fetching user data:', error);
          // If token is invalid, log out
          if (error.response && error.response.status === 401) {
            this.handleLogout();
          }
        });
    },

    toggleUserDropdown() {
      this.showUserDropdown = !this.showUserDropdown;
    },

    closeUserDropdown() {
      this.showUserDropdown = false;
    },

    handleOutsideClick(event) {
      const dropdown = this.$el.querySelector('.user-dropdown');
      if (dropdown && !dropdown.contains(event.target) && this.showUserDropdown) {
        this.closeUserDropdown();
      }
    },

    handleLogout() {
      // Call the auth service logout
      authService.logout();

      // Update local state
      this.isLoggedIn = false;
      this.userData = null;

      // Close the dropdown
      this.closeUserDropdown();

      // Redirect to login page
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.navbar {
  background-color: #2c5a57;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.navbar-brand {
  color: white;
}

.user-dropdown {
  cursor: pointer;
}

.user-role {
  color: #6c757d;
  font-style: italic;
  pointer-events: none;
}

.dropdown-menu.show {
  display: block;
}

/* New styles to ensure dropdown is visible */
.position-relative {
  position: relative;
}

.custom-dropdown-menu {
  right: 0;
  left: auto;
  min-width: 200px;
  /* Ensures a minimum width */
  transform: translateX(0);
  /* Removes any unwanted translation */
}
</style>